import { render, staticRenderFns } from "./AuthComponent.vue?vue&type=template&id=1ed74179"
import script from "./AuthComponent.vue?vue&type=script&lang=js"
export * from "./AuthComponent.vue?vue&type=script&lang=js"
import style0 from "./AuthComponent.vue?vue&type=style&index=0&id=1ed74179&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports